export enum MapVendor {
	Google = 1,
	Baidu = 2
}
